// extracted by mini-css-extract-plugin
module.exports = {"sbutton":"sbutton_sbutton__597Kj"};